import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import AddOrEditAnnotationDialog from "../AddOrEditAnnotationDialog";
import {
  ReactSelectField,
  getTagsAndTagOptions,
  CheckboxField,
  InfoHelper
} from "@teselagen/ui";
import { getFeatureTypes } from "@teselagen/sequence-utils";
import { get } from "lodash-es";
const RenderTypes = ({ readOnly, type }) => /* @__PURE__ */ jsx(
  ReactSelectField,
  {
    inlineLabel: true,
    tooltipError: true,
    disabled: readOnly,
    defaultValue: type ?? "misc_feature",
    options: getFeatureTypes().map((type2) => {
      return {
        label: type2,
        // label: (
        //   <div
        //     style={{
        //       display: "flex",
        //       alignItems: "center",
        //       marginRight: 10
        //     }}
        //   >
        //     <div
        //       style={{
        //         // background: getFeatureToColorMap()[type], add back in if we want colors. import from vesequtils
        //         height: 15,
        //         width: 15,
        //         marginRight: 5
        //       }}
        //     />
        //     {type}
        //   </div>
        // ),
        value: type2
      };
    }),
    name: "type",
    label: "Type"
  }
);
const renderAdvancedOptions = ({ readOnly }) => /* @__PURE__ */ jsx(
  CheckboxField,
  {
    inlineLabel: true,
    tooltipError: true,
    disabled: readOnly,
    name: "overlapsSelf",
    label: /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center" }, children: [
      "Part Overlaps Self",
      /* @__PURE__ */ jsx(
        InfoHelper,
        {
          style: { paddingLeft: 10, paddingTop: 9 },
          isInline: true,
          content: "If checked, this part will span the entire sequence and wrap back around on itself. (Useful for USER cloning and other instances where the part needs to span the entire sequence and then some)"
        }
      )
    ] })
  }
);
const getRenderTags = ({ readOnly, editTagsLink, tags }) => {
  return /* @__PURE__ */ jsx(
    ReactSelectField,
    {
      disabled: readOnly,
      inlineLabel: true,
      rightEl: editTagsLink,
      isTagSelect: true,
      multi: true,
      tooltipError: true,
      options: tags,
      name: "tags",
      label: "Tags"
    }
  );
};
export default AddOrEditAnnotationDialog({
  formName: "AddOrEditPartDialog",
  dialogProps: {
    width: 450
  },
  getProps: (props) => ({
    upsertAnnotation: props.upsertPart,
    advancedDefaultOpen: get(props, "initialValues.overlapsSelf"),
    advancedOptions: props.allowPartsToOverlapSelf ? renderAdvancedOptions({ readOnly: props.readOnly }) : void 0,
    RenderTypes,
    renderTags: props.allPartTags && getRenderTags({
      readOnly: props.readOnly,
      editTagsLink: props.editTagsLink,
      tags: getTagsAndTagOptions(props.allPartTags)
    }),
    annotationTypePlural: "parts"
  })
});
